import * as Routes from '@/modules/routes';

const ONLY = [
  'credits', 'description_confidence', 'description_en', 'description_es', 'english_image_only',
  'es_thumb_url', 'es_url', 'has_text', 'id', 'image_en_file_name', 'image_en_updated_at', 'image_es_file_name',
  'image_es_file_size', 'image_es_updated_at', 'image_file_size', 'thumb_url', 'title_en', 'title_es', 'url',
];

const EXTRA_ATTRIBUTES = ['num_of_uses'];

export const PAGE_SIZE = 500;
export const MAX_RECORDS = 1000;

export const IMAGES_PATH = Routes.plato_api_images_path({
  page: 'pageNumber',
  per_page: PAGE_SIZE,
  column: 'columnName',
  order: 'sortDirection',
  only: ONLY,
  extra_attributes: EXTRA_ATTRIBUTES,
  includes: ['image_models'],
});

export const SEARCH_IMAGES_PATH = Routes.plato_api_search_images_path({
  only: ONLY,
  extra_attributes: EXTRA_ATTRIBUTES,
});

export const LABEL_CLASSES = 'tw-w-[130px] tw-font-bold';
export const FIELD_CONTAINER_CLASSES = 'tw-flex tw-items-center';

export const IMAGE_FILTERS = [
  {
    label: 'Image ID',
    operators: ['eq', 'not_eq', 'cont', 'not_cont'],
    value: 'id',
  },
  {
    label: 'File Name (English)',
    value: 'image_en_file_name',
    operators: ['eq', 'not_eq', 'cont', 'not_cont'],
  },
  {
    label: 'File Name (Spanish)',
    value: 'image_es_file_name',
    operators: ['eq', 'not_eq', 'cont', 'not_cont', 'blank'],
  },
  {
    label: 'Title (English)',
    operators: ['eq', 'not_eq', 'cont', 'not_cont', 'blank'],
    value: 'title_en',
  },
  {
    label: 'Title (Spanish)',
    operators: ['eq', 'not_eq', 'cont', 'not_cont', 'blank'],
    value: 'title_es',
  },
  {
    label: 'Has Text',
    value: 'has_text',
    operators: ['eq'],
    isBoolean: true,
  },
  {
    label: 'Num of Uses',
    operators: ['eq', 'not_eq', 'gteq', 'lteq'],
    value: 'num_of_uses',
  },
];

export const INITIAL_IMAGE_FILTERS = [
  {
    operatorValue: 'gteq',
    propertyValue: 'num_of_uses',
    value: '1',
  },
];

const PARAM_REGEX = /\S*\[\S*]$/g;

export const getInitialImageFilters = () => {
  const params = new URLSearchParams(window.location.search);

  const initialFilters = [];

  params.forEach((value, key) => {
    const matches = key.match(PARAM_REGEX);

    if (!matches) return;

    const parts = key.split('[');
    const propertyValue = parts[0];
    const operatorValue = parts[1].replace('[', '').replace(']', '');

    initialFilters.push({
      operatorValue,
      propertyValue,
      value,
    });
  });

  const hasNumOfUsesKey = initialFilters.some(filter => filter.propertyValue === 'num_of_uses');
  const hasImageIdKey = initialFilters.some(filter => filter.propertyValue === 'id');

  if (!hasNumOfUsesKey && !hasImageIdKey) initialFilters.unshift(INITIAL_IMAGE_FILTERS[0]);

  return initialFilters;
};
